"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcRepetitionLabels = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const calcCustomRepetitionLabel_1 = __importDefault(require("@opsbase/lib-time/helpers/calcCustomRepetitionLabel"));
const niceTime_1 = require("@opsbase/lib-time/helpers/niceTime");
const nth_1 = require("@opsbase/lib-time/helpers/nth");
const shiftTZUTCToLocal_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZUTCToLocal"));
const RepetitionType_1 = __importDefault(require("@opsbase/lib-time/RepetitionType"));
function calcRepetitionLabels(schedule, short = false, excludeTime = false) {
    const { dueDate, customRepetition } = schedule;
    const utcDue = dueDate ? (0, shiftTZUTCToLocal_1.default)(dueDate) : undefined;
    let timeBit = excludeTime ? '' : ` @ ${(0, niceTime_1.niceTime)(utcDue)}`;
    const dayOfWeek = utcDue.format('dddd');
    const dayOfMonth = utcDue.format('Do');
    const weekOfMonth = calcWeekOfMonth(utcDue);
    const monthOfYear = utcDue.format('MMMM');
    return {
        [RepetitionType_1.default.NEVER]: lib_i18n_1.default.t('never'),
        [RepetitionType_1.default.DAILY]: lib_i18n_1.default.t('daily') + timeBit,
        [RepetitionType_1.default.WEEKLY]: short
            ? lib_i18n_1.default.t('weekly') + timeBit
            : lib_i18n_1.default.t('every') + ' ' + dayOfWeek + timeBit,
        [RepetitionType_1.default.MONTHLY]: short
            ? lib_i18n_1.default.t('monthly') + timeBit
            : lib_i18n_1.default.t('on-the-week-of-each-month', { weekOfMonth, dayOfWeek }) + timeBit,
        [RepetitionType_1.default.MONTHLY_BY_DATE]: short
            ? lib_i18n_1.default.t('monthly') + timeBit
            : lib_i18n_1.default.t('on-the-day-of-each-month', { dayOfMonth }) + timeBit,
        [RepetitionType_1.default.ANNUALLY]: short
            ? lib_i18n_1.default.t('annually') + timeBit
            : lib_i18n_1.default.t('on-the-week-of-each-year', {
                weekOfMonth,
                dayOfWeek,
                monthOfYear,
            }) + timeBit,
        [RepetitionType_1.default.ANNUALLY_BY_DATE]: short
            ? lib_i18n_1.default.t('annually') + timeBit
            : lib_i18n_1.default.t('on-the-monthday-of-each-year', {
                dayOfMonth,
                monthOfYear,
            }) + timeBit,
        [RepetitionType_1.default.CUSTOM]: (0, calcCustomRepetitionLabel_1.default)(utcDue, customRepetition, short),
    };
}
exports.calcRepetitionLabels = calcRepetitionLabels;
exports.default = calcRepetitionLabels;
function calcWeekOfMonth(m) {
    const wom = Math.ceil(m.date() / 7);
    if (wom === 5)
        return 'last';
    return (0, nth_1.nth)(wom);
}
